// ─────────────────────────────────────────────────────────────────────────────
// Sidebar.js
// Main navigation sidebar for contractor accounts.
//
// NAV ITEMS: Dashboard, Quotes, Invoices, Customers, Payments, Settings
// USER CARD: Shows email + sign out button at the bottom
//
// TO ADD A NEW NAV ITEM: Add an object to the navItems array below.
// ─────────────────────────────────────────────────────────────────────────────

import { useNavigate, useLocation } from 'react-router-dom'
import { supabase } from '../supabaseClient'

export default function Sidebar({ session }) {
  const navigate = useNavigate()
  const location = useLocation()

  const handleSignOut = async () => {
    await supabase.auth.signOut()
  }

  // ── Nav items ──────────────────────────────────────────────────────────────
  // Add new pages here. The active state is determined by matching the path.
  const navItems = [
    { label: 'Dashboard', path: '/dashboard' },
    { label: 'Quotes',    path: '/quotes'    },
    { label: 'Invoices',  path: '/invoices'  },
    { label: 'Customers', path: '/customers' },
    { label: 'Payments',  path: '/payments'  },
    { label: 'Settings',  path: '/settings'  },
  ]

  return (
    <div style={{
      width: '240px',
      height: '100vh',
      background: 'white',
      borderRight: '1px solid #EAECF0',
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      top: 0,
      left: 0,
    }}>

      {/* ── Top section ── */}
      <div style={{ padding: '24px 20px 16px 20px' }}>

        {/* Logo */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: '10px',
          marginBottom: '32px',
        }}>
          <div style={{
            width: '32px', height: '32px', borderRadius: '8px',
            background: 'linear-gradient(135deg, #2563EB, #1D4ED8)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: '800', color: 'white', fontSize: '15px',
          }}>Q</div>
          <span style={{ fontWeight: '700', fontSize: '15px', color: '#0F172A' }}>
            QuoteFlow
          </span>
        </div>

        {/* Menu label */}
        <p style={{
          fontSize: '11px', fontWeight: '600', color: '#94A3B8',
          textTransform: 'uppercase', letterSpacing: '0.8px', margin: '0 0 8px',
        }}>Menu</p>

        {/* Nav items */}
        {navItems.map((item, i) => {
          const active = location.pathname === item.path
          return (
            <div key={i} onClick={() => navigate(item.path)} style={{
              display: 'flex', alignItems: 'center', gap: '10px',
              padding: '9px 12px', marginBottom: '2px', borderRadius: '8px',
              background: active ? '#EFF6FF' : 'transparent',
              color: active ? '#2563EB' : '#64748B',
              fontWeight: active ? '600' : '500',
              fontSize: '13.5px', cursor: 'pointer',
              transition: 'background 0.15s',
            }}
              onMouseEnter={e => { if (!active) e.currentTarget.style.background = '#F8FAFC' }}
              onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent' }}
            >
              <div style={{
                width: '6px', height: '6px', borderRadius: '50%',
                background: active ? '#2563EB' : '#CBD5E1', flexShrink: 0,
              }} />
              {item.label}
            </div>
          )
        })}
      </div>

      {/* ── Spacer pushes user card to bottom ── */}
      <div style={{ flex: 1 }} />

      {/* ── User card — always at bottom ── */}
      <div style={{ padding: '16px 12px 24px 12px' }}>
        <div style={{
          padding: '12px 14px', borderRadius: '10px',
          background: '#F8FAFC', border: '1px solid #EAECF0',
        }}>
          <div style={{
            display: 'flex', alignItems: 'center',
            gap: '10px', marginBottom: '10px',
          }}>
            {/* Avatar initial */}
            <div style={{
              width: '28px', height: '28px', borderRadius: '50%',
              background: 'linear-gradient(135deg, #2563EB, #1D4ED8)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'white', fontSize: '11px', fontWeight: '700', flexShrink: 0,
            }}>
              {session?.user?.email?.[0]?.toUpperCase()}
            </div>
            <p style={{
              fontSize: '12px', fontWeight: '600', color: '#0F172A', margin: 0,
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>
              {session?.user?.email}
            </p>
          </div>
          <button onClick={handleSignOut} style={{
            width: '100%', padding: '6px', borderRadius: '6px',
            background: 'white', border: '1px solid #E2E8F0',
            fontSize: '12px', fontWeight: '600', color: '#64748B', cursor: 'pointer',
          }}>Sign out</button>
        </div>
      </div>

    </div>
  )
}